var render = function render(){var _vm=this,_c=_vm._self._c;return _c('JobList',{attrs:{"isMSDCustom":"","customCompanyId":_vm.customCompanyId}})
}
var staticRenderFns = []

export { render, staticRenderFns }